/**
 * Misconception Registry — module-based.
 *
 * This file is now a thin re-export shim. The actual definitions live in
 * `./misconceptions/<module>.ts` and are aggregated in
 * `./misconceptions/index.ts`.
 *
 * All existing imports (`from '@/governance/data/misconceptions'`) continue
 * to work unchanged.
 */

export type { MisconceptionDefinition } from './misconceptions/index';
export { MISCONCEPTION_REGISTRY, getMisconception, isKnownMisconception, getMisconceptionsForModule, getAllMisconceptionIds } from './misconceptions/index';